import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '@/config/locale';

void i18n.use(HttpBackend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: DEFAULT_LANGUAGE,
		supportedLngs: SUPPORTED_LANGUAGES,
		debug: false,
		detection: {
			order: ['querystring', 'localStorage', 'navigator'],
			lookupQuerystring: 'lang',
			lookupLocalStorage: 'i18nextLng',
			caches: ['localStorage'],
			excludeCacheFor: ['cimode'],
		},
		backend: {
			loadPath: '/locales/{{lng}}/{{ns}}.json',
		},
		react: {
			useSuspense: true,
			bindI18n: 'loaded languageChanged',
			bindI18nStore: 'added',
		},
		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
